import {Route} from '../helpers/Route';

export enum SearchKey {
  type = 'type',
  from = '',
  to = '',
  link = 'link',
}

export const route = {
  login: Route.of({path: '/login'}),
  magicLink: Route.of({path: '/magic-link-access'}),
  magicLinkSendgrid: Route.of({path: '/sendgrid-magic-link'}),
  forgot: Route.of({path: '/forgot-password'}),
  resetPassword: Route.of({path: '/reset-password'}),

  // authorized routes
  groups: Route.of({path: '/'}),
  groupView: Route.of<{id: string}>({path: '/group/:id'}),
  welcomeScreen: Route.of({path: '/welcome'}),
  cover: Route.of({path: '/cover'}),
  distribution: Route.of({path: '/distribution'}),
};

export const routePaths = {
  groupView: '/group/',
};
